import { BiSolidPhoneCall } from 'react-icons/bi';
import { FaFacebook, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { MdMail } from 'react-icons/md';
import { RiTwitterXLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import footerLogo from '../../../Images/loog-footer.png';
import './Footer.css';

const Footers = () => {
  return (
    <>
      <footer className=' py-16 border-y border-[#1C2134] footer-bg'>
        <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
          <div className='grid md:grid-cols-12 divide-y md:divide-y-0    justify-between gap-10'>
            <div className='md:col-span-6 lg:col-span-4'>
              <Link href='/' className='block mb-7'>
                <img src={footerLogo} width={200} height={200} alt='logo' />
              </Link>
              <p className='text-white text-base'>
                At MSTTC, we prepare learners with real-world, job - ready
                technical skills. Trough practical training, expert guidance,
                and industry-aligned programs, we help you learn with purpose
                and move confidently toward a stronger tech future.
              </p>
              <div className='flex space-x-3 mt-7'>
                <a
                  href='https://www.facebook.com/share/1aHKmZoTac/'
                  className='bg-[#1e2c46] text-[#9ca3af] hover:bg-primary hover:text-[#fff] transition-all text-lg w-10 h-10 rounded-full  inline-flex justify-center items-center'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaFacebook />
                </a>
                <a
                  href='https://x.com/'
                  className='bg-[#1e2c46] text-[#9ca3af] hover:bg-primary hover:text-[#fff] transition-all text-lg w-10 h-10 rounded-full  inline-flex justify-center items-center'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <RiTwitterXLine />
                </a>
                <a
                  href='https://www.youtube.com/'
                  className='bg-[#1e2c46] text-[#9ca3af] hover:bg-primary hover:text-[#fff] transition-all text-lg w-10 h-10 rounded-full  inline-flex justify-center items-center'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaYoutube />
                </a>
                <a
                  href='https://www.linkedin.com/'
                  className='bg-[#1e2c46] text-[#9ca3af] hover:bg-primary hover:text-[#fff] transition-all text-lg w-10 h-10 rounded-full  inline-flex justify-center items-center'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
            <div className='md:col-span-3 lg:col-span-2 pt-8 lg:pt-0 lg:pl-3'>
              <h4 className='mb-7 text-white text-2xl font-semibold'>
                About Us
              </h4>
              <nav>
                <ul className='space-y-4'>
                  <li>
                    <Link
                      to='/about'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/team'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      Our Team
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/courses'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      Courses
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/admission'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      Application From
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className='md:col-span-3 lg:col-span-2 pt-8 lg:pt-0 lg:pl-3'>
              <h4 className='mb-7 text-white text-2xl font-semibold'>
                Our Services
              </h4>
              <nav>
                <ul className='space-y-4'>
                  <li>
                    <a
                      href='#'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      Welding 1G to 4G
                    </a>
                  </li>
                  <li>
                    <a
                      href='#'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      Welding 4G to 6G +TIG
                    </a>
                  </li>
                  <li>
                    <a
                      href='#'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      1G to TIG Complate
                    </a>
                  </li>
                  <li>
                    <a
                      href='#'
                      className='font-medium text-base text-white hover:text-primary'
                    >
                      1G to 6G + MIG
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className='md:col-span-6 lg:col-span-4 pt-8 lg:pt-0 lg:pl-3'>
              <h4 className='mb-7 text-white text-2xl font-semibold'>
                Official Info:
              </h4>
              <ul className='space-y-4'>
                <li className='flex space-x-2'>
                  <FaLocationDot className='w-6 h-6 text-primary leading-none' />
                  <p className='text-white'>
                    Kahatergaon, Barachapa-1652, Monohardi, Narsingdi,
                    Bangladesh
                  </p>
                </li>
                <li className='flex space-x-2'>
                  <BiSolidPhoneCall className='w-6 h-6 text-primary leading-none' />
                  <a href='tel:01345336969' className='text-white text-base'>
                    Regular: +8801345336969
                  </a>
                </li>

                <li className='flex space-x-2'>
                  <MdMail className='w-6 h-6 text-primary leading-none' />

                  <a
                    href='tel:msolaimantechnicalcenter@gmail.com'
                    className='text-white text-base'
                  >
                    Email: msolaimantechnicalcenter@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <section className='px-4 bg-[#04091e] py-5'>
        <p className='text-base font-medium text-white text-center'>
          Copyright © {new Date().getFullYear()} –{' '}
          <a className='primary-color' href='#'>
            M. Solaiman Technical Traning Center
          </a>{' '}
          . All Rights Reserved
        </p>
      </section>
    </>
  );
};

export default Footers;
